module.exports = __webpack_public_path__ + "static/media/dat.90a80eb8.svg";